// AUTO-GENERATED by /app/scripts/generate_locales.py + build step.
// Adds all non-core languages: JSON locale trees + display metadata.
import { LANGUAGES as CORE } from "../translations";
import en_GB from "./en-GB.json";
import en_AU from "./en-AU.json";
import en_NZ from "./en-NZ.json";
import fr_CH from "./fr-CH.json";
import de_AT from "./de-AT.json";
import de_CH from "./de-CH.json";
import it_CH from "./it-CH.json";
import pt_PT from "./pt-PT.json";
import pt_BR from "./pt-BR.json";
import nl from "./nl.json";
import pl from "./pl.json";
import ru from "./ru.json";
import uk from "./uk.json";
import sv from "./sv.json";
import no from "./no.json";
import da from "./da.json";
import fi from "./fi.json";
import ga from "./ga.json";
import cy from "./cy.json";
import el from "./el.json";
import cs from "./cs.json";
import sk from "./sk.json";
import hu from "./hu.json";
import ro from "./ro.json";
import bg from "./bg.json";
import hr from "./hr.json";
import sr from "./sr.json";
import ca from "./ca.json";
import tr from "./tr.json";
import is from "./is.json";
import sl from "./sl.json";
import mt from "./mt.json";
import zh from "./zh.json";
import zh_Hant from "./zh-Hant.json";
import ja from "./ja.json";
import ko from "./ko.json";
import th from "./th.json";
import ka from "./ka.json";
import ar from "./ar.json";
import jam from "./jam.json";
import af from "./af.json";
import zu from "./zu.json";
import xh from "./xh.json";
import sw from "./sw.json";

export const extraLocales = {
  "en-GB": en_GB,
  "en-AU": en_AU,
  "en-NZ": en_NZ,
  "fr-CH": fr_CH,
  "de-AT": de_AT,
  "de-CH": de_CH,
  "it-CH": it_CH,
  "pt-PT": pt_PT,
  "pt-BR": pt_BR,
  "nl": nl,
  "pl": pl,
  "ru": ru,
  "uk": uk,
  "sv": sv,
  "no": no,
  "da": da,
  "fi": fi,
  "ga": ga,
  "cy": cy,
  "el": el,
  "cs": cs,
  "sk": sk,
  "hu": hu,
  "ro": ro,
  "bg": bg,
  "hr": hr,
  "sr": sr,
  "ca": ca,
  "tr": tr,
  "is": is,
  "sl": sl,
  "mt": mt,
  "zh": zh,
  "zh-Hant": zh_Hant,
  "ja": ja,
  "ko": ko,
  "th": th,
  "ka": ka,
  "ar": ar,
  "jam": jam,
  "af": af,
  "zu": zu,
  "xh": xh,
  "sw": sw,
};

export const EXTRA_LANGUAGES = [
  { code: "en-GB", label: "British English", short: "EN-GB", native: "English (UK)", dir: "ltr", script: "latin" },
  { code: "en-AU", label: "Australian English", short: "EN-AU", native: "English (Australia)", dir: "ltr", script: "latin" },
  { code: "en-NZ", label: "New Zealand English", short: "EN-NZ", native: "English (New Zealand)", dir: "ltr", script: "latin" },
  { code: "fr-CH", label: "Swiss French", short: "FR-CH", native: "Fran\u00e7ais (Suisse)", dir: "ltr", script: "latin" },
  { code: "de-AT", label: "Austrian German", short: "DE-AT", native: "Deutsch (\u00d6sterreich)", dir: "ltr", script: "latin" },
  { code: "de-CH", label: "Swiss German", short: "DE-CH", native: "Deutsch (Schweiz)", dir: "ltr", script: "latin" },
  { code: "it-CH", label: "Swiss Italian", short: "IT-CH", native: "Italiano (Svizzera)", dir: "ltr", script: "latin" },
  { code: "pt-PT", label: "European Portuguese", short: "PT", native: "Portugu\u00eas (Portugal)", dir: "ltr", script: "latin" },
  { code: "pt-BR", label: "Brazilian Portuguese", short: "PT-BR", native: "Portugu\u00eas (Brasil)", dir: "ltr", script: "latin" },
  { code: "nl", label: "Dutch", short: "NL", native: "Nederlands", dir: "ltr", script: "latin" },
  { code: "pl", label: "Polish", short: "PL", native: "Polski", dir: "ltr", script: "latin" },
  { code: "ru", label: "Russian", short: "RU", native: "\u0420\u0443\u0441\u0441\u043a\u0438\u0439", dir: "ltr", script: "cyrillic" },
  { code: "uk", label: "Ukrainian", short: "UK", native: "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430", dir: "ltr", script: "cyrillic" },
  { code: "sv", label: "Swedish", short: "SV", native: "Svenska", dir: "ltr", script: "latin" },
  { code: "no", label: "Norwegian", short: "NO", native: "Norsk", dir: "ltr", script: "latin" },
  { code: "da", label: "Danish", short: "DA", native: "Dansk", dir: "ltr", script: "latin" },
  { code: "fi", label: "Finnish", short: "FI", native: "Suomi", dir: "ltr", script: "latin" },
  { code: "ga", label: "Irish", short: "GA", native: "Gaeilge", dir: "ltr", script: "latin" },
  { code: "cy", label: "Welsh", short: "CY", native: "Cymraeg", dir: "ltr", script: "latin" },
  { code: "el", label: "Greek", short: "EL", native: "\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac", dir: "ltr", script: "greek" },
  { code: "cs", label: "Czech", short: "CS", native: "\u010ce\u0161tina", dir: "ltr", script: "latin" },
  { code: "sk", label: "Slovak", short: "SK", native: "Sloven\u010dina", dir: "ltr", script: "latin" },
  { code: "hu", label: "Hungarian", short: "HU", native: "Magyar", dir: "ltr", script: "latin" },
  { code: "ro", label: "Romanian", short: "RO", native: "Rom\u00e2n\u0103", dir: "ltr", script: "latin" },
  { code: "bg", label: "Bulgarian", short: "BG", native: "\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438", dir: "ltr", script: "cyrillic" },
  { code: "hr", label: "Croatian", short: "HR", native: "Hrvatski", dir: "ltr", script: "latin" },
  { code: "sr", label: "Serbian", short: "SR", native: "\u0421\u0440\u043f\u0441\u043a\u0438", dir: "ltr", script: "cyrillic" },
  { code: "ca", label: "Catalan", short: "CA", native: "Catal\u00e0", dir: "ltr", script: "latin" },
  { code: "tr", label: "Turkish", short: "TR", native: "T\u00fcrk\u00e7e", dir: "ltr", script: "latin" },
  { code: "is", label: "Icelandic", short: "IS", native: "\u00cdslenska", dir: "ltr", script: "latin" },
  { code: "sl", label: "Slovene", short: "SL", native: "Sloven\u0161\u010dina", dir: "ltr", script: "latin" },
  { code: "mt", label: "Maltese", short: "MT", native: "Malti", dir: "ltr", script: "latin" },
  { code: "zh", label: "Simplified Chinese", short: "ZH", native: "\u7b80\u4f53\u4e2d\u6587", dir: "ltr", script: "cjk-sc" },
  { code: "zh-Hant", label: "Traditional Chinese", short: "ZH-T", native: "\u7e41\u9ad4\u4e2d\u6587", dir: "ltr", script: "cjk-tc" },
  { code: "ja", label: "Japanese", short: "JA", native: "\u65e5\u672c\u8a9e", dir: "ltr", script: "cjk-jp" },
  { code: "ko", label: "Korean", short: "KO", native: "\ud55c\uad6d\uc5b4", dir: "ltr", script: "cjk-kr" },
  { code: "th", label: "Thai", short: "TH", native: "\u0e44\u0e17\u0e22", dir: "ltr", script: "thai" },
  { code: "ka", label: "Georgian", short: "KA", native: "\u10e5\u10d0\u10e0\u10d7\u10e3\u10da\u10d8", dir: "ltr", script: "georgian" },
  { code: "ar", label: "Modern Standard Arabic", short: "AR", native: "\u0627\u0644\u0639\u0631\u0628\u064a\u0629", dir: "rtl", script: "arabic" },
  { code: "jam", label: "Jamaican Patois", short: "JAM", native: "Jamaican Patois", dir: "ltr", script: "latin" },
  { code: "af", label: "Afrikaans", short: "AF", native: "Afrikaans", dir: "ltr", script: "latin" },
  { code: "zu", label: "Zulu", short: "ZU", native: "isiZulu", dir: "ltr", script: "latin" },
  { code: "xh", label: "Xhosa", short: "XH", native: "isiXhosa", dir: "ltr", script: "latin" },
  { code: "sw", label: "Swahili", short: "SW", native: "Kiswahili", dir: "ltr", script: "latin" },
];

const CORE_META = CORE.map((l) => ({ ...l, dir: "ltr", script: "latin" }));
export const ALL_LANGUAGES = [...CORE_META, ...EXTRA_LANGUAGES];
export const LANG_DIR = Object.fromEntries(ALL_LANGUAGES.map((l) => [l.code, l.dir]));
export const LANG_SCRIPT = Object.fromEntries(ALL_LANGUAGES.map((l) => [l.code, l.script]));

